const auth = () => {
    if(localStorage.getItem('autenticado_test')){
        return true
    }
    return false
}

export default auth;
